import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=05e01f22&"
import script from "./LanguageMenu.vue?vue&type=script&lang=js&"
export * from "./LanguageMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports